<template>
  <div class="benefit_box" id="benefit_box">
    <section class="benefits">
      <div class="left">
        <h2>
          How we benefit
          <span>Customers</span> ?
        </h2>
        <ul>
          <li>
            <i class="iconfont icon-shaixuan"></i>
            <div class="details">
              <h3>Place your order conveniently</h3>
              <p class="desc">
                Choose from a wide variety of lip-smacking cuisines on All Eat
                online food ordering platform
              </p>
            </div>
          </li>
          <li>
            <i class="iconfont icon-pound-sign"></i>
            <div class="details">
              <h3>Pay safe and secure</h3>
              <p class="desc">
                Seamlessly order takeaway and pay as you prefer- Cash/ PayPal/
                Card.
              </p>
            </div>
          </li>
          <li>
            <i class="iconfont icon-earnthepoint"></i>
            <div class="details">
              <h3>Earn Points</h3>
              <p class="desc">
                Earn points when you order food from All Eat and get discounts.
              </p>
            </div>
          </li>
        </ul>
      </div>
      <div class="right">
        <h2>
          How we benefit
          <span>Merchants</span> ?
        </h2>
        <ul>
          <li>
            <i class="iconfont icon-tuandui"></i>
            <div class="details">
              <h3>Get More users</h3>
              <p class="desc">
                Join hands with All Eat Platform to attract more customers and
                earn more profits
              </p>
            </div>
          </li>
          <li>
            <i class="iconfont icon-zhankai"></i>
            <div class="details">
              <h3>Menu optimisation</h3>
              <p class="desc">
                Easily update your menu and promote your offerings/deals with
                our easy to navigate platform
              </p>
            </div>
          </li>
          <li>
            <i class="iconfont icon-pound-sign"></i>
            <div class="details">
              <h3>Receive weekly payments</h3>
              <p class="desc">Effortless and regular payments every week</p>
            </div>
          </li>
        </ul>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  created() {},
  methods: {},
};
</script>

<style lang="scss" scoped>
$mainColor: #aa0bc0;
$greenColor: #26d07c;
$yellowColor: #ffa132;
.benefit_box {
  display: flex;
  justify-content: center;
  align-items: center;
  background: #ffffff;
  padding: 50px 0;
  .benefits {
    display: flex;
    width: 1120px;
    justify-content: space-between;
    .left {
      width: 534px;
      h2 {
        margin: 0 0 17px 0;
        color: #000;
        font-size: 36px;
        font-weight: 700;
        span {
          color: $mainColor;
          transition: all ease-in 0.2s;
          font-family: "Playfair Display", Sans-serif;
          font-size: 36px;
          font-weight: 700;
          font-style: italic;
          &:hover {
            color: $greenColor;
          }
        }
      }
      ul {
        display: flex;
        flex-direction: column;
        padding-left: 30px;
        border-left: 1px solid $mainColor;
        li {
          display: flex;
          align-items: center;
          height: 140px;
          margin-bottom: 12px;
          padding-left: 10px;
          cursor: default;
          i {
            display: inline-block;
            padding: 20px;
            color: $mainColor;
            font-size: 43px;
            background-color: #fff;
            border: 1px solid $mainColor;
            border-radius: 50px;
            transition: all ease-in 0.2s;
          }

          &:hover {
            box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.5);
            backdrop-filter: #fff;
            border-radius: 6px;
            i {
              color: #fff;
              background-color: $greenColor;
              border: 1px solid $greenColor;
            }
          }

          .details {
            width: 352px;
            margin-left: 30px;
            h3 {
              padding: 0 0 0 0;
              margin-bottom: 26px;
              color: #111633;
              font-family: "Raleway", Sans-serif;
              font-size: 21px;
              font-weight: 700;
              line-height: 25px;
            }
            p {
              padding: 0;
              margin-bottom: 20px;
              color: #565656;
              font-family: "Open Sans", Sans-serif;
              font-size: 15px;
              font-weight: 400;
              line-height: 25px;
            }
          }
        }
      }
    }
    .right {
      width: 534px;
      h2 {
        margin: 0 0 17px 0;
        color: #000;
        font-size: 36px;
        font-weight: 700;
        span {
          color: $greenColor;
          font-family: "Playfair Display", Sans-serif;
          font-size: 36px;
          font-weight: 700;
          font-style: italic;
          transition: all ease-in 0.2s;
          &:hover {
            color: $mainColor;
          }
        }
      }
      ul {
        display: flex;
        flex-direction: column;
        padding-left: 30px;
        border-left: 1px solid $greenColor;
        li {
          display: flex;
          align-items: center;
          height: 140px;
          margin-bottom: 12px;
          padding-left: 10px;
          i {
            display: inline-block;
            padding: 20px;
            color: $greenColor;
            font-size: 43px;
            background-color: #fff;
            border: 1px solid $greenColor;
            border-radius: 50px;
            transition: all ease-in 0.2s;
          }

          &:hover {
            box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.5);
            backdrop-filter: #fff;
            border-radius: 6px;
            i {
              color: #fff;
              background-color: $mainColor;
              border: 1px solid $mainColor;
            }
          }

          .details {
            width: 352px;
            margin-left: 30px;
            h3 {
              padding: 0 0 0 0;
              margin-bottom: 26px;
              color: #111633;
              font-family: "Raleway", Sans-serif;
              font-size: 21px;
              font-weight: 700;
              line-height: 25px;
            }
            p {
              padding: 0;
              margin-bottom: 20px;
              color: #565656;
              font-family: "Open Sans", Sans-serif;
              font-size: 15px;
              font-weight: 400;
              line-height: 25px;
            }
          }
        }
      }
    }
  }
}
</style>
